import { render } from "./FolderManagementSection.vue?vue&type=template&id=3975879f"
import script from "./FolderManagementSection.vue?vue&type=script&lang=js"
export * from "./FolderManagementSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__